import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { RememberService } from '@app/core/services/remember.service';
import { StateService } from '@app/core/services/state.service';
import { TranslateService } from '@app/core/services/translate.service';
import { DocArticleGet, DocArticleService } from '@app/services/doc-article.service';

@Component({
    selector: 'tt-doc-article',
    exportAs: 'docArticle',
    templateUrl: './doc-article.component.html',
    styleUrls: ['./doc-article.component.css'],
})
export class DocArticleComponent extends ComponentBaseComponent implements OnChanges {
    @Input()
    public params?: { docarticle_keyno: string | number };

    @Output()
    public submit = new EventEmitter<{ back: number; docarticle_keyno: string }>();

    public get?: DocArticleGet;

    public relatedArticles: Item[] = [];

    public editKeyno?: string | number;

    constructor(private docarticle: DocArticleService, public state: StateService, private remember: RememberService, private cdr: ChangeDetectorRef, translate: TranslateService) {
        translate.translated$.subscribe({ next: () => cdr.markForCheck() });
        super();
    }

    public onSubmit(event: { back: number; docarticle_keyno: string }) {
        if (event.back !== 2) {
            delete this.editKeyno;
            this.loadGet();
        } else {
            delete this.editKeyno;
            delete this.get;
        }

        this.submit.emit(event);
    }

    public async create() {
        if (!!this.params) {
            await this.remember.remember('docarticle_keyno_belongto', this.params.docarticle_keyno);
            this.editKeyno = '0';
            this.cdr.markForCheck();
        }
    }

    public async gotoCreate() {
        if (!!this.params) {
            await this.remember.remember('docarticle_keyno_belongto', this.params.docarticle_keyno);
            this.state.go('docarticleedit', { docarticle_keyno: '0' });
        }
    }

    public async loadRelatedArticles() {
        if (!!this.get && this.get.docarticle_keyno > '0') {
            this.relatedArticles = await this.docarticle.getDocarticleList(this.get?.docarticle_keyno);
            this.cdr.markForCheck();
        }
    }

    public async loadGet() {
        if (!!this.params) {
            delete this.editKeyno;

            const data = await this.docarticle.getDocArticle(this.params.docarticle_keyno);
            let htmlContent = '';

            try {
                htmlContent = this.base64UrlDecode(data.html_content_base64);
            } catch (error) {
                console.error(error);
            }

            this.get = { ...data, html_content_base64: htmlContent };

            if (this.get.docarticle_keyno === '0') {
                this.editKeyno = '0';
            } else {
                delete this.editKeyno;
            }

            this.cdr.markForCheck();
        }
    }

    private async loadDocArticle() {
        delete this.editKeyno;
        delete this.get;
        this.cdr.markForCheck();
        await this.loadGet();
        await this.loadRelatedArticles();
        this.cdr.markForCheck();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params'] && typeof changes['params'].currentValue === 'object' && 'docarticle_keyno' in changes['params'].currentValue && changes['params'].currentValue.docarticle_keyno > '') {
            this.loadDocArticle();
        }
    }
}

// interface DocArticleGet {
//     docarticle_keyno: string;
//     title: string;
//     html_content_base64: string;
//     docarticle_keyno_belongto: string;
//     reg_portal_user_name: string;
//     reg_date: string;
//     mod_portal_user_name: string;
//     mod_date: string;
//     nbr_of_read: string;
//     docarticle_keyno_top: string;
//     sub_docarticle_admin: string;
//     page_heading: string;
//     gb_docarticle_main: string;
// }
